<template>
  <div class="menuList">
    <!-- {{ datas }} -->
    <ListItem v-for="(item, index) in datas" :key="index" :datas="item"></ListItem>
    <BottomBtn class="menuListBtn" :data="btnData" @click="clickBtn" align="center" size="small"></BottomBtn>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
import ListItem from '@/components/shop/MenuListItem'
import BottomBtn from '@/components/order/BottomBtn'
import { setSession, getSession, setLocal, getLocal } from '@/util'

export default {
  name: 'MenuList',
  components: {
    ListItem,
    BottomBtn
  },
  props: {
    datas: {
      default: () => [],
      type: Array
    }
  },
  emits: ['clickBtn'],
  setup(props, { emit }) {
    let store = useStore()
    let { datas } = toRefs(props)
    const state = reactive({
      datas,
      btnData: [
        {
          text: '重置',
          btnId: 'reset'
        },
        {
          text: '确定',
          btnId: 'sure',
          type: 'active'
        }
      ]
    })
    const selectShopMenuItem = computed(() => store.state.selectShopMenuItem)
    const clickBtn = v => {
      // const selectShopMenuItemSession = getSession('selectShopMenuItem')
      if (v.btnId === 'sure') {
        setSession('selectShopMenuItem', selectShopMenuItem.value)
      }
      if (v.btnId === 'reset') {
        store.commit('SETSELECTSHOPMENUITEM', [])
      }
      emit('clickBtn', v)
    }
    onMounted(async () => {
      // console.log('onMounted----------MenuList')
    })
    return {
      ...toRefs(state),
      clickBtn
    }
  }
}
</script>

<style lang="scss" scoped>
.menuList {
  background: #fff;
  height: 100%;
  font-size: 14px;
  margin-bottom: calc(constant(safe-area-inset-bottom) + 50px);
  margin-bottom: calc(env(safe-area-inset-bottom) + 50px);
}
.menuListBtn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 10px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 10px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 10px);
  background: #fff;
  box-shadow: 0px 2px 15px #aaa;
}
</style>
